var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4398 25.8187C21.9477 26.2905 21.2957 26.5485 20.6017 26.5485L20.6006 26.5485C19.1652 26.5485 18 25.4286 18 24.0557V20.3551C18 19.7846 18.4816 19.3229 19.0768 19.3229C19.672 19.3229 20.1537 19.7846 20.1537 20.3551V24.0557C20.1537 24.2936 20.3556 24.4841 20.6006 24.4841C20.7194 24.4841 20.833 24.4377 20.9161 24.3581L28.2762 17.3028C28.6958 16.9006 29.3804 16.8975 29.8 17.3028C30.2196 17.7081 30.2196 18.3612 29.8 18.7635L22.4398 25.8187ZM20.201 31.2369L27.5612 24.1816C28.0533 23.7099 28.7053 23.4518 29.3994 23.4518C30.8348 23.4518 32 24.5718 32 25.9447V29.6453C32 30.2158 31.5183 30.6775 30.9231 30.6775C30.3279 30.6775 29.8463 30.2158 29.8463 29.6453V25.9447C29.8463 25.7068 29.6444 25.5163 29.3994 25.5163C29.2805 25.5163 29.1669 25.5627 29.0839 25.6423L21.7237 32.6976C21.5145 32.8992 21.24 33 20.9624 33C20.6858 33 20.4114 32.8992 20.201 32.6976C19.7815 32.2923 19.7815 31.6391 20.201 31.2369Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon1);
export default __webpack_public_path__ + "static/media/nav_icon_1.2b452c3855d14ce29aa077da97b02a1f.svg";
export { ForwardRef as ReactComponent };